const e=({showBorderLeft:e,showBorderRight:t,isRtl:n})=>[e?n?`show-border-right`:`show-border-left`:``,t?n?`show-border-left`:`show-border-right`:``].join(` `);export{e as addBorderClasses};
//# sourceMappingURL=common.js.map